import React from 'react';
import LandingFrugal from './LandingFrugal';

// zensaver Landing Page - Plan Frugal ($2.99/mes o $29.99/año)
export default function LandingPage() {
  return <LandingFrugal />;
}
